<template>
  <div class="main_right">
    <div class="page_info">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem>角色管理</BreadcrumbItem>
      </Breadcrumb>
      <div class="searchBox">
        <div>
          <Button type="primary" icon="plus" @click="addRoleBox = true" v-if="authList.indexOf('003001') !== -1">添加</Button>
          <Button type="error" icon="minus" @click="batchDelete" v-if="authList.indexOf('003005') !== -1">删除</Button>
        </div>
        <Input v-model="reqbody.searchKey" icon="ios-search" placeholder="用户名/所属公司" style="width: 200px" @on-click="search" @keyup.13.native="search"/>
      </div>

      <Table border height="520" ref="user_table" :columns="columns" :data="tableData" @on-select-all="setAllBatch" @on-select="setBatch" @on-select-cancel="delBatch"></Table>
      <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
    </div>

    <Modal
      v-model="openSimple"
      title="提示"
      @on-ok="sureDelete"
      @on-cancel="cancelDelete">
      <p>是否确认删除角色？</p>
    </Modal>
    <Modal
      v-model="addRoleBox"
      title="添加角色"
      @on-ok="sureAddRole"
      @on-cancel="cancelAddRole">
      <div>
        <span style="display: inline-block;width: 80px;text-align: right;margin-right: 10px;"><b style="color: red;margin-right: 5px;">*</b>角色名</span><Input v-model="roleName" style="width: 300px" :maxlength=32 />
      </div>
      <div style="display: flex;justify-content: flex-start;max-height: 320px;overflow-y: auto;">
        <div style="line-height: 34px;">
          <span style="display: inline-block;width: 80px;text-align: right;margin-right: 10px;"><b style="color: red;margin-right: 5px;">*</b>角色权限</span>
        </div>
        <div>
          <Tree :data="authListTree" show-checkbox ref="authListTree"></Tree>
        </div>
      </div>
    </Modal>
    <Modal
      v-model="modifyRoleBox"
      title="修改角色"
      @on-ok="sureModifyRole"
      @on-cancel="cancelModifyRole">
      <div>
        <span style="display: inline-block;width: 80px;text-align: right;margin-right: 10px;"><b style="color: red;margin-right: 5px;">*</b>角色名</span><Input v-model="roleName" style="width: 300px" :maxlength=32 />
      </div>
      <div style="display: flex;justify-content: flex-start;max-height: 320px;overflow-y: auto;">
        <div style="line-height: 34px;">
          <span style="display: inline-block;width: 80px;text-align: right;margin-right: 10px;"><b style="color: red;margin-right: 5px;">*</b>角色权限</span>
        </div>
        <div>
          <Tree :data="authListTree" show-checkbox ref="authListTree2"></Tree>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import TopOpe from '../top-ope/top-ope'
import {errorHandler} from '../../util/errorHandler'
import {nSuccess, nError} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  components: {TopOpe},
  name: 'role-management',
  data () {
    return {
      authList: '',
      authListTree: [{
        title: '全部',
        expand: true,
        children: [{
          title: '设备管理',
          children: [{
            title: '查询设备',
            code: '001000'
          }, {
            title: '升级设备',
            code: '001006'
          }, {
            title: '导出设备',
            code: '001008'
          }]
        }, {
          title: '版本管理',
          children: [{
            title: '查询版本',
            code: '002000'
          }, {
            title: '添加版本',
            code: '002002'
          }, {
            title: '删除版本',
            code: '002001'
          }]
        }, {
          title: '配置管理',
          children: [{
            title: '查询配置',
            code: '004000'
          }, {
            title: '添加配置',
            code: '004001'
          }, {
            title: '修改配置',
            code: '004002,004004'
          }, {
            title: '删除配置',
            code: '004003'
          }]
        }, {
          title: '操作日志',
          children: [{
            title: '查询操作日志',
            code: '005000'
          }, {
            title: '导出操作日志',
            code: '005001'
          }]
        }, {
          title: 'MAC配置',
          children: [{
            title: '查询MAC',
            code: '006000,007001,008001'
          }, {
            title: '添加MAC',
            code: '006001'
          }, {
            title: '导出MAC',
            code: '006002'
          }]
        }, {
          title: '生产批次',
          children: [{
            title: '查询生产批次',
            code: '007000'
          }, {
            title: '添加生产批次',
            code: '007002'
          }]
        }, {
          title: '固件版本',
          children: [{
            title: '查询固件版本',
            code: '008000'
          }, {
            title: '添加固件版本',
            code: '008002'
          }]
        }, {
          title: '产品型号',
          children: [{
            title: '查询产品型号',
            code: '013003'
          }, {
            title: '添加产品型号',
            code: '013001'
          }, {
            title: '删除产品型号',
            code: '013002'
          }]
        }, {
          title: '合作伙伴',
          children: [{
            title: '查询合作伙伴',
            code: '009000'
          }, {
            title: '添加合作伙伴',
            code: '009002'
          }, {
            title: '修改合作伙伴',
            code: '009003,009004'
          }, {
            title: '删除合作伙伴',
            code: '009005'
          }]
        }, {
          title: '商户管理',
          children: [{
            title: '查询商户',
            code: '010000'
          }, {
            title: '添加商户',
            code: '010002'
          }, {
            title: '修改商户',
            code: '010003,010004'
          }, {
            title: '删除商户',
            code: '010005'
          }]
        }, {
          title: '出入库管理',
          children: [
            // {
            //   title: '查询出入库记录',
            //   code: '009001,011000'
            // }, {
            //   title: '修改出入库记录',
            //   code: '011002'
            // },
            {
              title: '导出出入库记录',
              code: '011004'
            }
          ]
        }, {
          title: '账户管理',
          children: [{
            title: '查询用户',
            code: '003000'
          }, {
            title: '添加用户',
            code: '003001,012001'
          }, {
            title: '修改用户',
            code: '003002,003004,012001'
          }, {
            title: '修改密码',
            code: '003003'
          }, {
            title: '删除用户',
            code: '003005'
          }, {
            title: '查询角色',
            code: '012000'
          }, {
            title: '添加角色',
            code: '012002'
          }, {
            title: '修改角色',
            code: '012003,012004'
          }, {
            title: '删除角色',
            code: '012005'
          }]
        }]
      }],
      openSimple: false,
      addRoleBox: false,
      modifyRoleBox: false,
      modifyRoleId: '',
      roleName: '',
      reqbody: {
        searchKey: '',
        pageSize: 10,
        pageNo: 1
      },
      columns: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '角色名',
        key: 'name',
        align: 'center'
      }, {
        title: '操作',
        key: 'operation',
        align: 'center',
        render: (h, params) => {
          if (params.row.authStatusM && !params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifyRole(params.row.id, params.row.name)
                  }
                }
              }, '修改')
            ])
          } else if (!params.row.authStatusM && params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteRoles(params.row.id)
                  }
                }
              }, '删除')
            ])
          } else if (params.row.authStatusM && params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifyRole(params.row.id, params.row.name)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteRoles(params.row.id)
                  }
                }
              }, '删除')
            ])
          }
        }
      }],
      tableData: [],
      total: 0,
      deleteDevId: {},
      batchId: {
        ids: ''
      }
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getUserPage()
  },
  methods: {
    getUserPage () {
      this.$axios.post(`${httpUrl.url}/manage/authority/getPage`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (this.authList.indexOf('003004') !== -1) {
              data.list.map(v => {
                v.authStatusM = true
              })
            } else {
              data.list.map(v => {
                v.authStatusM = false
              })
            }
            if (this.authList.indexOf('003005') !== -1) {
              data.list.map(v => {
                v.authStatusD = true
              })
            } else {
              data.list.map(v => {
                v.authStatusD = false
              })
            }
            this.tableData = data.list
            this.total = data.total
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    setAllBatch (selection) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    setBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    delBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    batchDelete () {
      if (!this.batchId.ids) {
        nError('请先选择设备')
        return false
      }
      this.deleteRoles(this.batchId.ids)
    },
    modifyRole (id, name) {
      this.$axios.post(`${httpUrl.url}/manage/authority/getPermissionsByRoleId`, {
        id: id
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.roleName = name
            this.modifyRoleId = id
            let codeStr = ''
            let data = res.data.data
            data.map(v => {
              codeStr += v.code + ','
            })
            let newCodeStr = codeStr.slice(0, codeStr.length - 1)
            this.authListTree[0].children.map(v => {
              v.children.map(value => {
                if (value.code.indexOf(',') !== -1) {
                  let firstCode = value.code.split(',')[0]
                  if (newCodeStr.indexOf(firstCode) !== -1) {
                    value.checked = true
                  }
                }
                if (newCodeStr.indexOf(value.code) !== -1) {
                  value.checked = true
                }
              })
            })
            this.authListTree[0].expand = false
            this.modifyRoleBox = true
          }
        })
        .catch(errorHandler('查询角色信息失败'))
    },
    deleteRoles (id) {
      this.openSimple = true
      this.deleteDevId.ids = id.toString()
    },
    sureDelete () {
      this.$axios.post(`${httpUrl.url}/manage/authority/deleteByIds`, this.deleteDevId)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.openSimple = false
            this.reqbody.pageNo = 1
            this.getUserPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    cancelDelete () {
      this.openSimple = false
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getUserPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getUserPage()
    },
    search () {
      this.reqbody.pageNo = 1
      this.getUserPage()
    },
    sureAddRole () {
      if (!this.roleName) {
        nError('添加失败，请输入角色名')
        return false
      }
      let authArr = this.$refs.authListTree.getCheckedNodes()
      if (!authArr.length) {
        nError('添加失败，请选择角色权限')
        return false
      }
      let authStr = ''
      authArr.map(v => {
        if (v.code) {
          authStr += v.code + ','
        }
      })
      let newAuthStr = authStr.slice(0, authStr.length - 1)
      let authCode = newAuthStr.split(',')
      let authList = []
      authCode.map(v => {
        if (authList.indexOf(v) === -1) {
          authList.push(v)
        }
      })
      this.$axios.post(`${httpUrl.url}/manage/authority/addRole`, {
        name: this.roleName,
        permissionCodes: authList
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.roleName = ''
            this.getUserPage()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    cancelAddRole () {},
    sureModifyRole () {
      if (!this.roleName) {
        nError('添加失败，请输入角色名')
        return false
      }
      let authArr = this.$refs.authListTree2.getCheckedNodes()
      if (!authArr.length) {
        nError('添加失败，请选择角色权限')
        return false
      }
      let authStr = ''
      authArr.map(v => {
        if (v.code) {
          authStr += v.code + ','
        }
      })
      let newAuthStr = authStr.slice(0, authStr.length - 1)
      let authCode = newAuthStr.split(',')
      let authList = []
      authCode.map(v => {
        if (authList.indexOf(v) === -1) {
          authList.push(v)
        }
      })
      this.$axios.post(`${httpUrl.url}/manage/authority/updateRole`, {
        id: this.modifyRoleId,
        name: this.roleName,
        permissionCodes: authList
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.roleName = ''
            this.getUserPage()
          }
        })
        .catch(errorHandler('修改失败'))
    },
    cancelModifyRole () {}
  },
  watch: {
    modifyRoleBox (v) {
      if (!v) {
        this.authListTree = [{
          title: '全部',
          expand: true,
          children: [{
            title: '设备管理',
            children: [{
              title: '查询设备',
              code: '001000'
            }, {
              title: '升级设备',
              code: '001006'
            }, {
              title: '导出设备',
              code: '001008'
            }]
          }, {
            title: '版本管理',
            children: [{
              title: '查询版本',
              code: '002000'
            }, {
              title: '添加版本',
              code: '002002'
            }, {
              title: '删除版本',
              code: '002001'
            }]
          }, {
            title: '配置管理',
            children: [{
              title: '查询配置',
              code: '004000'
            }, {
              title: '添加配置',
              code: '004001'
            }, {
              title: '修改配置',
              code: '004002,004004'
            }, {
              title: '删除配置',
              code: '004003'
            }]
          }, {
            title: '操作日志',
            children: [{
              title: '查询操作日志',
              code: '005000'
            }, {
              title: '导出操作日志',
              code: '005001'
            }]
          }, {
            title: 'MAC配置',
            children: [{
              title: '查询MAC',
              code: '006000,007001,008001'
            }, {
              title: '添加MAC',
              code: '006001'
            }, {
              title: '导出MAC',
              code: '006002'
            }]
          }, {
            title: '生产批次',
            children: [{
              title: '查询生产批次',
              code: '007000'
            }, {
              title: '添加生产批次',
              code: '007002'
            }]
          }, {
            title: '固件版本',
            children: [{
              title: '查询固件版本',
              code: '008000'
            }, {
              title: '添加固件版本',
              code: '008002'
            }]
          }, {
            title: '合作伙伴',
            children: [{
              title: '查询合作伙伴',
              code: '009000'
            }, {
              title: '添加合作伙伴',
              code: '009002'
            }, {
              title: '修改合作伙伴',
              code: '009003,009004'
            }, {
              title: '删除合作伙伴',
              code: '009005'
            }]
          }, {
            title: '商户管理',
            children: [{
              title: '查询商户',
              code: '010000'
            }, {
              title: '添加商户',
              code: '010002'
            }, {
              title: '修改商户',
              code: '010003,010004'
            }, {
              title: '删除商户',
              code: '010005'
            }]
          }, {
            title: '出入库管理',
            children: [{
              title: '查询出入库记录',
              code: '009001,011000'
            }, {
              title: '修改出入库记录',
              code: '011002'
            }, {
              title: '导出出入库记录',
              code: '011004'
            }]
          }, {
            title: '账户管理',
            children: [{
              title: '查询用户',
              code: '003000'
            }, {
              title: '添加用户',
              code: '003001,012001'
            }, {
              title: '修改用户',
              code: '003002,003004,012001'
            }, {
              title: '修改密码',
              code: '003003'
            }, {
              title: '删除用户',
              code: '003005'
            }, {
              title: '查询角色',
              code: '012000'
            }, {
              title: '添加角色',
              code: '012002'
            }, {
              title: '修改角色',
              code: '012003,012004'
            }, {
              title: '删除角色',
              code: '012005'
            }]
          }]
        }]
      }
    }
  }
}
</script>

<style scoped>
  .main_right {
    min-width: 780px;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }
  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/role-management.vue